import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { Row, Col } from 'antd';
import { Animated } from "react-animated-css";

import AdPlatformCard from '../../components/advertisement/adplatformcard';
import AdLocationCard from '../../components/advertisement/adlocationcard';
import AdImpressionIdCard from '../../components/advertisement/adimpressionidcard';
import AdImpressionAppCard from '../../components/advertisement/adimpressionappcard';
import AdImpressionUserLocationCard from '../../components/advertisement/adimpressionuserlocation';



import './Advertisement.css';

import {
	
	opensearchAdImpressionPlatform,
	opensearchAdImpressionLocation,
	opensearchAdImpressionId,
	opensearchCtaClickAdId,
	advertisementGetOrder,
	advertisementGetOrderAll,
	opensearchAdImpressionApp,
	opensearchAdImpressionUserLocation

} from '../../modules/advertisement';

class AdsAnlytics extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loadingactiveusers: false,
			loadingOrder: false,
		}
	}

	async componentDidMount() {
		const { opensearchAdImpressionByPlatformList,opensearchAdImpressionByLocationList,opensearchAdImpressionByIdList,opensearchCtaClickByAdIdList, advertisementOrderList,advertisementOrderListAll,
			opensearchAdImpressionByAppList,opensearchAdImpressionByUserLocationList } = this.props;	
		if(!opensearchAdImpressionByPlatformList){
			this.getAdImpressionByPlatformList();
		}
		if(!opensearchAdImpressionByLocationList){
			this.getAdImpressionByLocationList();
		}
		if(!opensearchAdImpressionByIdList){
			this.getAdImpressionByIdList();
		}
		if(!opensearchCtaClickByAdIdList){
			this.getCtaClickByAdIdList();
		}
		if(!opensearchAdImpressionByAppList){
			this.getAdImpressionAppList();
		}
		if(!opensearchAdImpressionByUserLocationList){
			this.getAdImpressionUserLocationList();
		}
	
		if (!advertisementOrderList){
			this.props.advertisementGetOrder();
		}
		if (!advertisementOrderListAll){
			this.props.advertisementGetOrderAll();
		}
		

	}

	async componentDidUpdate(prevProps) {
		const { opensearchAdImpressionByPlatformList,opensearchAdImpressionByLocationList,opensearchAdImpressionByIdList,opensearchCtaClickByAdIdList,advertisementOrderList,advertisementOrderListAll,
			opensearchAdImpressionByAppList,opensearchAdImpressionByUserLocationList } = this.props;
		if(!opensearchAdImpressionByPlatformList && JSON.stringify(opensearchAdImpressionByPlatformList) !== JSON.stringify(prevProps.opensearchAdImpressionByPlatformList)){
			this.getAdImpressionByPlatformList();
		}
		if(!opensearchAdImpressionByLocationList && JSON.stringify(opensearchAdImpressionByLocationList) !== JSON.stringify(prevProps.opensearchAdImpressionByLocationList)){
			this.getAdImpressionByLocationList();
		}
		if(!opensearchAdImpressionByIdList && JSON.stringify(opensearchAdImpressionByIdList) !== JSON.stringify(prevProps.opensearchAdImpressionByIdList)){
			this.getAdImpressionByIdList();
		}
		if(!opensearchCtaClickByAdIdList && JSON.stringify(opensearchCtaClickByAdIdList) !== JSON.stringify(prevProps.opensearchCtaClickByAdIdList)){
			this.getCtaClickByAdIdList();
		}
		if(!opensearchAdImpressionByAppList && JSON.stringify(opensearchAdImpressionByAppList) !== JSON.stringify(prevProps.opensearchAdImpressionByAppList)){
			this.getAdImpressionAppList();
		}
		if(!opensearchAdImpressionByUserLocationList && JSON.stringify(opensearchAdImpressionByUserLocationList) !== JSON.stringify(prevProps.opensearchAdImpressionByUserLocationList)){
			this.getAdImpressionUserLocationList();
		}
		if(!advertisementOrderList && JSON.stringify(advertisementOrderList) !== JSON.stringify(prevProps.advertisementOrderList)){
			this.setState({ loadingOrder: true });
			await this.props.advertisementGetOrder();
			this.setState({ loadingOrder: false });
		}
		if(!advertisementOrderListAll && JSON.stringify(advertisementOrderListAll) !== JSON.stringify(prevProps.advertisementOrderListAll)){
			this.setState({ loadingOrder: true });
			await this.props.advertisementGetOrderAll();
			this.setState({ loadingOrder: false });
		}

	}

	
	getAdImpressionByPlatformList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingactiveusers: true });
		await this.props.opensearchAdImpressionPlatform(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingactiveusers: false });
	}
	getAdImpressionByLocationList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingactiveusers: true });
		await this.props.opensearchAdImpressionLocation(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingactiveusers: false });
	}
	getAdImpressionByIdList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingactiveusers: true });
		await this.props.opensearchAdImpressionId(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingactiveusers: false });
	}
	getCtaClickByAdIdList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingactiveusers: true });
		await this.props.opensearchCtaClickAdId(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingactiveusers: false });
	}
	getAdImpressionAppList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingactiveusers: true });
		await this.props.opensearchAdImpressionApp(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingactiveusers: false });
	}
	getAdImpressionUserLocationList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingactiveusers: true });
		await this.props.opensearchAdImpressionUserLocation(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingactiveusers: false });
	}


	render() {
		const { loadingactiveusers } = this.state;

		return (
			<Animated animationIn="fadeIn">
				<div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
					<Row>
						<Col md={24} lg={24} xl={24} xxl={24}>
							<Row>
									<Col span={12}>
									<AdLocationCard loading={loadingactiveusers}/>
								</Col>
								<Col span={12}>
									<AdImpressionUserLocationCard loading={loadingactiveusers}/>
								</Col>
							</Row>
							<Row>
									<Col span={24}>
									<AdImpressionIdCard loading={loadingactiveusers}/>
								</Col>
								{/* <Col span={12}>
									<CtaClickAdId loading={loadingactiveusers}/>
								</Col> */}
							</Row>
							<Row>
								<Col span={12}>
									<AdImpressionAppCard loading={loadingactiveusers}/>
								</Col>
								<Col span={12}>
									<AdPlatformCard loading={loadingactiveusers}/>
								</Col>
							</Row>
						</Col>
					</Row>
				</div>
			</Animated>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile,
	selectedOrganization: state.user.selectedOrganization,
	inspectionTime: state.analytics.inspectionTime,
	opensearchAdImpressionByPlatformList : state.advertisement.opensearchAdImpressionByPlatformList,
	opensearchAdImpressionByLocationList : state.advertisement.opensearchAdImpressionByLocationList,
	opensearchAdImpressionByIdList: state.advertisement.opensearchAdImpressionByIdList,
	opensearchCtaClickByAdIdList: state.advertisement.opensearchCtaClickByAdIdList,
	advertisementOrderList: state.advertisement.advertisementOrderList,
	opensearchAdImpressionByAppList : state.advertisement.opensearchAdImpressionByAppList,
	opensearchAdImpressionByUserLocationList : state.advertisement.opensearchAdImpressionByUserLocationList
	
	
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			opensearchAdImpressionPlatform,
			opensearchAdImpressionLocation,
			opensearchAdImpressionId,
			opensearchCtaClickAdId,
			advertisementGetOrder,
			advertisementGetOrderAll,
			opensearchAdImpressionApp,
			opensearchAdImpressionUserLocation
			
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AdsAnlytics);
